import { ReactNode } from 'react';
import { useMajorResultStyles } from '../MajorResult.styles';
import { useSummarySectionStyles } from './SummarySection.styles';

type SummaryCardProps = {
  title: string;
  children: ReactNode;
  beforeTitle?: ReactNode;
};

export const SummaryCard = ({ title, children, beforeTitle }: SummaryCardProps) => {
  const shared = useMajorResultStyles();
  const local = useSummarySectionStyles();
  const classes = { ...shared, ...local };

  return (
    <div className={classes.summaryCard}>
      {beforeTitle}
      <h2 className={classes.summaryCardTitle}>{title}</h2>
      <div className={classes.summaryCardBody}>{children}</div>
    </div>
  );
};

export const SummarySideCards = ({ children }: { children: ReactNode }) => {
  const classes = useSummarySectionStyles();
  return <div className={classes.sideCardsStack}>{children}</div>;
};

export const DetailsSection = ({ title, children }: { title: string; children: ReactNode }) => {
  const shared = useMajorResultStyles();
  const local = useSummarySectionStyles();
  const classes = { ...shared, ...local };

  return (
    <section className={classes.detailsSection}>
      <h2 className={classes.detailsSectionTitle}>{title}</h2>
      <div className={classes.detailsGrid}>{children}</div>
    </section>
  );
};

export const SummaryGrid = ({ children }: { children: ReactNode }) => {
  const classes = useSummarySectionStyles();
  return <div className={classes.summaryGrid}>{children}</div>;
};
